export const IMPORT_STATUS = {
    pending: { label: 'Pendiente', color: 'grey' },
    queued: { label: 'En cola', color: 'cyan-darken-2' },
    processing: { label: 'Procesando', color: 'indigo' },
    completed: { label: 'Completado', color: 'green' },
    failed: { label: 'Fallido', color: 'red' },
    cancelled: { label: 'Cancelado', color: 'grey-darken-1' },
};

export const TERMINAL_STATUSES = ['completed', 'failed', 'cancelled'];

export const ACTIVE_STATUSES = ['pending', 'queued', 'processing'];

export function statusInfo (status) {
    return IMPORT_STATUS[status] || { label: status, color: 'grey' };
}

export function isTerminal (status) {
    return TERMINAL_STATUSES.includes(status);
}
